export enum CurrencyCode {
  GBP = 'GBP',
  USD = 'USD',
  AUD = 'AUD',
}
